export interface MediaApiUrlProps {
  url: string;
  crop?: string | undefined;
  format?: string | undefined;
  rotation?: number | null | undefined;
  smartCrop?: string | undefined;
  width?: number | undefined;
  quality?: number | undefined;
}

export interface MediaUrlParams {
  url: string | undefined;
  crop: string | undefined;
  format: string | undefined;
}

export function extractParamsFromMediaUrl(
  mediaUrl: string | null | undefined
): MediaUrlParams {
  if (!mediaUrl) {
    return { url: undefined, crop: undefined, format: undefined };
  }

  const url = mediaUrl.split(/(~|\.[\dA-Za-z]{3,4}$)/)[0];

  const match = mediaUrl.match(/cr_((?:\d+\.){3}\d+)/);

  const crop = (match && match[1]) || undefined;

  const formatMatch = mediaUrl.match(/\.([\dA-Za-z]{3,4})$/);

  const format = (formatMatch && formatMatch[1]) || undefined;

  return { url, crop, format };
}

export function mediaApiUrl(props: MediaApiUrlProps): string {
  const processedUrl = prepareBaseImageUrl(props);

  return applyLoaderTransforms({
    url: processedUrl,
    width: props.width,
    quality: props.quality,
  });
}

export function prepareBaseImageUrl(props: MediaApiUrlProps): string {
  const { crop, rotation, smartCrop, url } = props;

  // Prevents legacy urls from injecting old transform params.
  // They should first be extracted and then passed into this function.
  // This ensures only the desired transforms are applied in the correct order.
  const trimmedUrl = url.split(/~[rt_|cr_|sc_|rs_]/).shift() || url;

  const transforms = [];

  if (rotation) {
    transforms.push(`rt_${rotation}`);
  } else {
    transforms.push('rt_auto');
  }

  if (smartCrop) {
    transforms.push(`sc_${smartCrop}`);
  } else if (crop) {
    transforms.push(`cr_${crop}`);
  }

  return `${trimmedUrl}~${transforms.join('-')}`;
}

export const applyLoaderTransforms = (props: MediaApiUrlProps): string => {
  const { url, width, quality } = props;

  const urlParts = url.split('?');

  let result = urlParts[0] || '';

  if (width) {
    const hasTransforms = result.includes('~');
    result = `${result}${hasTransforms ? '-' : '~'}rs_${width}.h`;
  }

  const qualityParam = `quality=${quality || 80}`;
  const hasQuery = urlParts.length === 2;

  return `${result}${hasQuery ? `?${urlParts[1]}&` : '?'}ordering=explicit&${qualityParam}`;
};
